import produce from 'immer'
import CONTACTS from 'constants/Contacts'
import * as C from './constants'

const { department, guest, teamMember, welcomeMenu, ringGroup, callQueues } =
  CONTACTS.names

const contactsReducer = (state = C.INITIAL_STATE, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      // TEAM MEMBERS
      case C.TEAM_MEMBERS_FETCH_PENDING:
        draft[teamMember + C.LOADING] = true
        draft[teamMember + C.ERROR] = false
        break
      case C.TEAM_MEMBERS_FETCH_FULFILLED:
        draft[teamMember + C.LOADING] = false
        draft[teamMember + C.ERROR] = false
        draft[C.DATA_MAP][teamMember] = action.payload
        break
      case C.TEAM_MEMBERS_FETCH_REJECTED:
        draft[teamMember + C.LOADING] = false
        draft[teamMember + C.ERROR] = action.payload
        break

      // DEPARTMENTS
      case C.DEPARTMENTS_FETCH_PENDING:
        draft[department + C.LOADING] = true
        draft[department + C.ERROR] = false
        break
      case C.DEPARTMENTS_FETCH_FULFILLED:
        draft[department + C.LOADING] = false
        draft[department + C.ERROR] = false
        draft[C.DATA_MAP][department] = action.payload
        break
      case C.DEPARTMENTS_FETCH_REJECTED:
        draft[department + C.LOADING] = false
        draft[department + C.ERROR] = action.payload
        break

      // CALL_QUEUES
      case C.CALL_QUEUES_FETCH_PENDING:
        draft[callQueues + C.LOADING] = true
        draft[callQueues + C.ERROR] = false
        break
      case C.CALL_QUEUES_FETCH_FULFILLED:
        draft[callQueues + C.LOADING] = false
        draft[callQueues + C.ERROR] = false
        draft[C.DATA_MAP][callQueues] = action.payload
        break
      case C.CALL_QUEUES_FETCH_REJECTED:
        draft[callQueues + C.LOADING] = false
        draft[callQueues + C.ERROR] = action.payload
        break

      // WELCOME MENUS
      case C.WELCOME_MENUS_FETCH_PENDING:
        draft[welcomeMenu + C.LOADING] = true
        draft[welcomeMenu + C.ERROR] = false
        break
      case C.WELCOME_MENUS_FETCH_FULFILLED:
        draft[welcomeMenu + C.LOADING] = false
        draft[welcomeMenu + C.ERROR] = false
        draft[C.DATA_MAP][welcomeMenu] = action.payload
        break
      case C.WELCOME_MENUS_FETCH_REJECTED:
        draft[welcomeMenu + C.LOADING] = false
        draft[welcomeMenu + C.ERROR] = action.payload
        break

      // RING GROUPS
      case C.RING_GROUPS_FETCH_PENDING:
        draft[ringGroup + C.LOADING] = true
        draft[ringGroup + C.ERROR] = false
        break
      case C.RING_GROUPS_FETCH_FULFILLED:
        draft[ringGroup + C.LOADING] = false
        draft[ringGroup + C.ERROR] = false
        draft[C.DATA_MAP][ringGroup] = action.payload
        break
      case C.RING_GROUPS_FETCH_REJECTED:
        draft[ringGroup + C.LOADING] = false
        draft[ringGroup + C.ERROR] = action.payload
        break

      // GUESTS
      case C.GUESTS_FETCH_PENDING:
        draft[guest + C.LOADING] = true
        draft[guest + C.ERROR] = false
        break
      case C.GUESTS_FETCH_FULFILLED:
        draft[guest + C.LOADING] = false
        draft[guest + C.ERROR] = false
        draft[C.DATA_MAP][guest] = action.payload
        break
      case C.GUESTS_FETCH_REJECTED:
        draft[guest + C.LOADING] = false
        draft[guest + C.ERROR] = action.payload
        break

      // SEARCH
      case C.SEARCH:
      case C.SEARCH_KEY_PENDING:
      case C.SEARCH_KEY_FULFILLED:
        draft.search = action.payload
        break
      case C.SEARCH_FULFILLED:
        draft.filteredIds = action.payload
        break
      case C.SEARCH_CLEAR:
        draft.search = ''
        draft.filteredIds = []
        break

      // CONTACTS
      case C.SELECTED_SET:
        draft.selected = action.payload.contact
        if (action.payload.clear) {
          draft.filteredIds = []
          draft.search = ''
        }
        break
      case C.SELECTED_CLEAR:
        draft.selected = false
        if (action.payload) {
          draft.filteredIds = []
        }
        break

      // TYPE
      case C.SELECTED_TYPE_SET:
        draft.type = action.payload
        break
      case C.SELECTED_TYPE_CLEAR:
        draft.type = false
        break

      // SYNC TOKEN
      case C.SYNC_TOKEN_SET:
        draft.token = action.payload
        break
      case C.SYNC_TOKEN_CLEAR:
        draft.token = false
        break

      // DEFAULT
      default:
        break
    }
  })
}

export default contactsReducer
